'use strict';
import * as $j_app$002edata$002e$002dCookie$002dApp$002dAuth$002dData from "./app.data.-Cookie-App-Auth-Data.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_CookieAppAuthData$() {
}
export { $c_Lapp_data_CookieAppAuthData$ as $c_Lapp_data_CookieAppAuthData$ };
$c_Lapp_data_CookieAppAuthData$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_CookieAppAuthData$.prototype.constructor = $c_Lapp_data_CookieAppAuthData$;
/** @constructor */
function $h_Lapp_data_CookieAppAuthData$() {
}
export { $h_Lapp_data_CookieAppAuthData$ as $h_Lapp_data_CookieAppAuthData$ };
$h_Lapp_data_CookieAppAuthData$.prototype = $c_Lapp_data_CookieAppAuthData$.prototype;
$c_Lapp_data_CookieAppAuthData$.prototype.given_TapirCodec_String_CookieAppAuthData_TextPlain__Lsttp_tapir_Codec__Lsttp_tapir_Codec = (function(codec) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec(codec, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$1) => new $j_app$002edata$002e$002dCookie$002dApp$002dAuth$002dData.$c_Lapp_data_CookieAppAuthData(_$1))), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((_$2) => _$2.Lapp_data_CookieAppAuthData__f_auth)));
});
$c_Lapp_data_CookieAppAuthData$.prototype.fromProduct__s_Product__Lapp_data_CookieAppAuthData = (function(x$0) {
  var auth$1 = x$0.productElement__I__O(0);
  return new $j_app$002edata$002e$002dCookie$002dApp$002dAuth$002dData.$c_Lapp_data_CookieAppAuthData(auth$1);
});
$c_Lapp_data_CookieAppAuthData$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_data_CookieAppAuthData(p);
});
var $d_Lapp_data_CookieAppAuthData$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_CookieAppAuthData$, "app.data.CookieAppAuthData$", ({
  Lapp_data_CookieAppAuthData$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_data_CookieAppAuthData$ as $d_Lapp_data_CookieAppAuthData$ };
var $n_Lapp_data_CookieAppAuthData$;
function $m_Lapp_data_CookieAppAuthData$() {
  if ((!$n_Lapp_data_CookieAppAuthData$)) {
    $n_Lapp_data_CookieAppAuthData$ = new $c_Lapp_data_CookieAppAuthData$();
  }
  return $n_Lapp_data_CookieAppAuthData$;
}
export { $m_Lapp_data_CookieAppAuthData$ as $m_Lapp_data_CookieAppAuthData$ };
//# sourceMappingURL=app.data.-Cookie-App-Auth-Data$.js.map
